import axios from "axios";
import { logout } from "../MainService";

export const baseUrl = process.env.REACT_APP_BASE_URL;

export const Axios = axios.create({
  baseURL: `${baseUrl}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});
Axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  config.headers.Accept = "application/json";
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers.Laundryzoneid = sessionStorage.getItem("zone");
  return config;
});

Axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (err) => {
    if (err.response?.status === 401) {
      logout();
    }
    return Promise.reject(err.response?.data || err);
  }
);
